import React, { useState, useEffect } from "react";
import { Shield, ArrowRight } from "lucide-react";
import { FaWhatsapp, FaGooglePlay } from "react-icons/fa";
import { ref, onValue } from "firebase/database";
import { rtdb } from "../config/firebase";

function HeroSection() {
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const galeriRef = ref(rtdb, "halamanutama");
    onValue(galeriRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const imgs = Object.values(data)
          .map((item) => item.url)
          .filter(Boolean);
        setImages(imgs);
      }
    });
  }, []);

  useEffect(() => {
    if (images.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images]);

  return (
    <section
      id="beranda"
      className="relative bg-white min-h-screen flex items-center py-20 px-4 md:px-16 overflow-hidden"
    >
      {/* 🔹 Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <img
          src="/images/foto2.jpg"
          alt="Background Logo"
          className="absolute inset-0 w-full h-full object-cover scale-150 brightness-90 opacity-30 z-0"
        />
        <div className="absolute top-1/4 -left-20 w-[500px] h-[500px] bg-green-300/40 rounded-full filter blur-[130px] animate-pulse" />
        <div
          className="absolute bottom-1/4 -right-20 w-[500px] h-[500px] bg-teal-300/40 rounded-full filter blur-[130px] animate-pulse"
          style={{ animationDelay: "1s" }}
        />
      </div>

      {/* 🔹 Konten utama */}
      <div className="relative z-10 max-w-7xl mx-auto w-full">
        <div className="flex items-center gap-3 mb-8 animate-fade-in">
          <div className="flex items-center gap-2 px-4 py-2 bg-green-100 border border-green-300 rounded-full">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span className="text-green-700 text-xs font-mono uppercase tracking-wider">
              AMAN
            </span>
          </div>
          <div className="px-4 py-2 bg-gray-100 border border-gray-300 rounded-full">
            <span className="text-gray-600 text-xs font-mono">SONEY RAYA</span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Kolom kiri */}
          <div className="space-y-8">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-black leading-[0.9] tracking-tighter">
              <span
                className="block text-gray-900 opacity-0 animate-slide-up"
                style={{
                  animationDelay: "0.1s",
                  animationFillMode: "forwards",
                }}
              >
                Keamanan
              </span>
              <span
                className="block text-gray-900 opacity-0 animate-slide-up"
                style={{
                  animationDelay: "0.2s",
                  animationFillMode: "forwards",
                }}
              >
                Tenaga
              </span>
              <span
                className="block opacity-0 animate-slide-up"
                style={{
                  animationDelay: "0.3s",
                  animationFillMode: "forwards",
                }}
              >
                <span className="relative inline-block">
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-500 via-teal-500 to-green-600 animate-gradient">
                    Profesional
                  </span>
                </span>
              </span>
            </h1>

            <p
              className="text-lg md:text-2xl text-gray-700 leading-relaxed max-w-xl font-light opacity-0 animate-fade-in"
              style={{ animationDelay: "0.6s", animationFillMode: "forwards" }}
            >
              Layanan keamanan profesional dari Soney Raya,{" "}
              <span className="text-gray-900 font-semibold">
                tim satpam siap siaga
              </span>{" "}
              untuk melindungi aset Anda.
            </p>

            {/* 2. AREA TOMBOL (Sudah dimodifikasi untuk 1 Baris di HP) */}
            <div
              className="flex flex-row items-stretch gap-3 pt-4 w-full sm:w-auto opacity-0 animate-fade-in"
              style={{ animationDelay: "0.8s", animationFillMode: "forwards" }}
            >
              {/* Tombol WhatsApp */}
              <a
                href="https://wa.me/6281247691112"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 sm:flex-none group relative px-4 py-3 sm:px-8 sm:py-4 bg-green-600 text-white font-bold rounded-xl overflow-hidden shadow-lg hover:bg-green-700 transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2 sm:gap-3 border border-green-500"
              >
                <FaWhatsapp className="w-5 h-5 sm:w-6 sm:h-6" />
                <span className="text-sm sm:text-lg whitespace-nowrap">
                  WhatsApp
                </span>
                {/* Arrow disembunyikan di HP agar muat, muncul di Tablet/PC */}
                <ArrowRight className="hidden sm:block w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
              </a>

              {/* Tombol Play Store */}
              <a
                href="https://play.google.com/store/apps/details?id=com.soneyraya.peteandroid"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 sm:flex-none group relative px-3 py-2 sm:px-6 sm:py-3 bg-green-600 text-white rounded-xl overflow-hidden shadow-lg hover:bg-green-700 transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2 sm:gap-3 border border-green-500"
              >
                <FaGooglePlay className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
                <div className="flex flex-col items-start leading-none justify-center">
                  <span className="text-[8px] sm:text-[10px] font-medium text-green-100 uppercase tracking-wide">
                    GET IT ON
                  </span>
                  <span className="text-sm sm:text-lg font-bold whitespace-nowrap">
                    Google Play
                  </span>
                </div>
              </a>
            </div>
          </div>

          {/* Kolom kanan — Slideshow */}
          <div
            className="relative opacity-0 animate-fade-in"
            style={{ animationDelay: "0.4s", animationFillMode: "forwards" }}
          >
            <div className="relative group">
              <div className="relative h-[400px] md:h-[500px] rounded-3xl overflow-hidden border border-gray-200 shadow-2xl transform group-hover:scale-[1.02] transition-all duration-500">
                {images.length > 0 && (
                  <img
                    src={images[currentIndex]}
                    alt={`Tim Keamanan Soney Raya - ${currentIndex + 1}`}
                    className="object-cover w-full h-full brightness-100 group-hover:brightness-105 transition-all duration-500 group-hover:scale-110"
                  />
                )}
                <div className="absolute bottom-6 left-6 right-6 p-4 bg-white/70 backdrop-blur-md rounded-xl border border-gray-200">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-gray-900 font-semibold">SONEY RAYA</p>
                      <p className="text-gray-500 text-sm">
                        Selalu Siap, Selalu Waspada
                      </p>
                    </div>
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-green-500 to-teal-500 flex items-center justify-center">
                      <Shield className="w-6 h-6 text-white" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CSS Animasi */}
      <style>{`
        @keyframes slide-up { from { opacity:0; transform: translateY(30px);} to {opacity:1; transform:translateY(0);} }
        @keyframes fade-in { from {opacity:0;} to {opacity:1;} }
        @keyframes gradient { 0%,100%{background-position:0% 50%;}50%{background-position:100% 50%;} }
        .animate-slide-up{animation: slide-up 0.6s ease-out;}
        .animate-fade-in{animation: fade-in 0.8s ease-out;}
        .animate-gradient{background-size:200% 200%; animation:gradient 3s ease infinite;}
      `}</style>
    </section>
  );
}

export default HeroSection;
